import { createContext, useContext, useState, useCallback } from "react";
import { dictionaries } from "../lib/translations";

const LanguageContext = createContext(null);
const STORAGE_KEY = "app_lang";

function initialLang() {
  const v = typeof localStorage !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
  if (v === "nl" || v === "en") return v; // explicit user choice wins
  // No saved choice yet: auto-detect from the browser, defaulting Dutch speakers to nl.
  const browser = (typeof navigator !== "undefined" ? (navigator.language || (navigator.languages && navigator.languages[0]) || "") : "").toLowerCase();
  return browser.startsWith("nl") ? "nl" : "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(initialLang);

  const setLang = useCallback((l) => {
    const v = l === "nl" ? "nl" : "en";
    localStorage.setItem(STORAGE_KEY, v);
    setLangState(v);
  }, []);

  const t = useCallback((en) => (lang === "nl" ? (dictionaries.nl[en] ?? en) : en), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext) || { lang: "en", setLang: () => {}, t: (en) => en };
}

// Compact EN/NL segmented toggle used in Profile and Login.
export function LangToggle({ className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex rounded-lg border border-zinc-700 overflow-hidden ${className}`} data-testid="lang-toggle">
      {["en", "nl"].map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLang(l)}
          data-testid={`lang-${l}`}
          className={`px-3 py-1.5 text-xs font-bold transition-colors ${lang === l ? "bg-[#F26722] text-white" : "bg-transparent text-zinc-400 hover:text-white"}`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
